import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {LocalV2Service} from "app/core/services/v2-refactored/local-v2.service";
import {BehaviorSubject, map, Observable, ReplaySubject, switchMap, take, tap} from "rxjs";
import {Shortcut} from "./shortcut.model";
import { ShortcutV2Service } from "./shortcuts-V2.service";
import { List } from "app/core/interfaces/generics/list.interface";

@Injectable({ providedIn: "root" })
export class ShortcutsService {
  private _localV2Service = inject(LocalV2Service);
  private _shortcutV2Service = inject(ShortcutV2Service);
  private _shortcuts: BehaviorSubject<Shortcut[]> = new BehaviorSubject<
    Shortcut[]
  >([]);
  private _shortcut: BehaviorSubject<Shortcut> = new BehaviorSubject<Shortcut>(
    null
  );

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for shortcuts
   */
  get shortcuts$(): Observable<Shortcut[]> {
    return this._shortcuts.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * init
   */
  init(): void {
    // this._localV2Service.loadFromStorage();
  }

  /**
   * Get all messages
   */
  // getAll(): Observable<List<Shortcut>> {
  //   return this._shortcutV2Service.getAll().pipe(
  //     tap((res: List<Shortcut>) => {
  //       if (res.data) {
  //         this._shortcuts.next(res.data);
  //         return res.data;
  //       }
  //     })
  //   );
  // }

  getAll(): Observable<List<Shortcut>> {
    return this._shortcutV2Service.getAll().pipe(
      tap(
        {
          next: 
          (res: List<Shortcut>) => {
            if (res.data) {
              this._shortcuts.next(res.data);
              return res.data;
            }
          },
          error: (err) => {
            console.log("err", err);
          }
        }                
    ));
  }


  /**
   * Create a shortcut
   *
   * @param shortcut
   */
  createShortcut(item: Shortcut) {
    return this.shortcuts$.pipe(
      take(1),
      switchMap((shortcuts) => {
        const currentShortcut = Array.isArray(shortcuts) ? shortcuts : [];

        return this._shortcutV2Service.createItem(item).pipe(
          map((newShortcut) => {
            // Update the users with the new user
            const updatedItem = { ...item, oid: newShortcut.data.oid };

            this._shortcuts.next([updatedItem, ...currentShortcut]);

            // Return the new user
            return newShortcut; 
          })
        );
        // this._localV2Service.createShortcut(shortcut).pipe(
        //     map((updatedShortcuts) => {
        //         // Update the shortcuts with the new shortcut
        //         this._shortcuts.next(updatedShortcuts);
        //         // Return the new shortcut from observable
        //         return updatedShortcuts;
        //     })
        // )
      })
    );
  }

  /**
   * Update the shortcut
   *
   * @param id
   * @param shortcut
   */

  updateShortcut(oid: string, data: Shortcut) {
    return this.shortcuts$.pipe(
      take(1),
      switchMap(
        (shortcuts) =>
          this._shortcutV2Service.updateItem(data).pipe(
            map((updatedUser) => {
              // Find the index of the updated user
              const index = shortcuts.findIndex((item) => item.oid === oid);

              shortcuts[index] = data;

              this._shortcuts.next(shortcuts);
              this._shortcut.next(data);
              return data;
            })
          )
        // this._localV2Service.updateShortcut(shortcut).pipe(
        //     map((updatedShortcut: Shortcut) => {
        //         // Find the index of the updated shortcut
        //         const index = shortcuts.findIndex((item) => item.id === id);

        //         // Update the shortcut (create a new array to trigger change detection)
        //         const updatedShortcuts = [...shortcuts];
        //         updatedShortcuts[index] = updatedShortcut;

        //         // Update the shortcuts
        //         this._shortcuts.next(updatedShortcuts);

        //         // Return the updated shortcut
        //         return updatedShortcuts;
        //     })
        // )
      )
    );
  }
  /**
   * Delete the shortcut
   *
   * @param id
   */
  deleteShortcut(oid: string) {
    return this.shortcuts$.pipe(
      take(1),
      switchMap((shortcuts) =>
        this._shortcutV2Service.deleteItem(oid).pipe(
          tap((isDeleted) => {
            // Find the index of the deleted user
            const index = shortcuts.findIndex((item) => item.oid === oid);

            // Delete the user
            shortcuts.splice(index, 1);

            // Update the users
            this._shortcuts.next(shortcuts);

            // Return the deleted status
            return isDeleted;
          })
        )
      )
    );
  }

  deleteAllShortcuts() {
    return this.shortcuts$.pipe(
      take(1),
      switchMap((shortcuts) =>
        this._shortcutV2Service.deleteAllShortcuts().pipe(
          map((isDeleted: boolean) => {
            // Delete all shortcuts
            shortcuts = [];

            // Update the shortcuts
            this._shortcuts.next(null);
            // Return the deleted status
            return isDeleted;
          })
        )
      )
    );
  }
}